import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { combinedSettingsSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type PieChartsComponentProps } from "./component";
import { makePieChartsOptionsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const pieChartsOptionsSelector = makePieChartsOptionsSelector();

  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["percent", "pieRadius"]);

  return (state: AppState, props: RootContainerProps): PieChartsComponentProps => {
    const settings = settingsSelector(state, props);

    return {
      options: pieChartsOptionsSelector(state, props),
      ...settings,
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
